(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["specifications-table"] && !Shopify.designMode) return;
  try {
    
(() => {
  const convert = (raw, type) => {
    const text = raw.trim().replace(/\u00a0/g, ' ');
    const normalized = text.replace(/(\d),(?=\d{3}(?:\D|$))/g, '$1');
    const units = {pitch:/\s*mm\s*$/i, power:/\s*W\s*\/\s*m(?:²|2|\^2)\s*$/i, distance:/\s*m\s*$/i};
    if (!units[type] || !units[type].test(normalized)) return raw;
    const numbers = normalized.replace(units[type], '');
    if (!/^[\d.\s×xX*≥≤><≈~+–—-]+$/.test(numbers)) return raw;
    const factor = type === 'pitch' ? 1 / 25.4 : type === 'power' ? 0.09290304 : 1 / 0.3048;
    const digits = type === 'pitch' ? 3 : type === 'power' ? 2 : 1;
    const unit = type === 'pitch' ? 'in' : type === 'power' ? 'W/ft²' : 'ft';
    return numbers.replace(/\d+(?:\.\d+)?/g, value => (Number(value) * factor).toFixed(digits)).trim() + ' ' + unit;
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-specifications]').forEach(section => {
      if (section.dataset.unitsReady) return;
      section.dataset.unitsReady = 'true';
      const cells = Array.from(section.querySelectorAll('[data-conversion]'));
      cells.forEach(cell => { cell.dataset.converted = cell.dataset.imperial || convert(cell.dataset.metric, cell.dataset.conversion); });
      const buttons = Array.from(section.querySelectorAll('[data-unit]'));
      const switchTo = (unit, announce = true) => {
        cells.forEach(cell => { cell.textContent = unit === 'imperial' ? cell.dataset.converted : cell.dataset.metric; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
        const active = buttons.find(button => button.dataset.unit === unit);
        const status = section.querySelector('[data-unit-status]');
        if (announce && active && status) status.textContent = active.textContent;
      };
      buttons.forEach(button => button.addEventListener('click', () => switchTo(button.dataset.unit)));
      const controls = section.querySelector('[data-unit-controls]');
      if (controls) controls.hidden = false;
      switchTo(section.dataset.defaultUnits === 'imperial' ? 'imperial' : 'metric', false);
    });

    root.querySelectorAll('[data-led-difference]').forEach(experience => {
      if (experience.dataset.ledReady) return;
      experience.dataset.ledReady = 'true';
      const tabs = Array.from(experience.querySelectorAll('[data-led-topic]'));
      const panels = Array.from(experience.querySelectorAll('[data-led-panel]'));
      const activate = (index, focus = false) => {
        const selected = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === selected));
          tab.tabIndex = i === selected ? 0 : -1;
          if (panels[i]) panels[i].hidden = i !== selected;
        });
        if (focus) tabs[selected].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          const next = ['ArrowRight','ArrowDown'].includes(event.key);
          const prev = ['ArrowLeft','ArrowUp'].includes(event.key);
          if (!next && !prev && !['Home','End'].includes(event.key)) return;
          event.preventDefault();
          activate(event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : index + (next ? 1 : -1), true);
        });
      });

      const power = experience.querySelector('[data-led-power]');
      if (power) {
        power.addEventListener('click', () => {
          const off = experience.classList.toggle('is-off');
          power.setAttribute('aria-pressed', String(!off));
          const label = experience.querySelector('[data-led-power-label]');
          const source = experience.querySelector(off ? '[data-led-off]' : '[data-led-on]');
          if (label && source) label.textContent = source.textContent;
        });
      }

      const controls = experience.querySelector('[data-led-controls]');
      if (controls) controls.hidden = false;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
